module.exports = __webpack_public_path__ + "static/img/icon-email.f4a66b6b.png";